<template>
  <page-view class="tms-shell-order tms-style">
    <div slot="pageRight">
      <div class="order-search">
        <div style="display: flex;justify-content: space-between;">
            <div class="title" style="display: flex; padding-bottom: 16px">
            <span
                style="color: #9c9c9c; cursor: pointer"
                @click="goBoard"
            >
            {{ $t('DomesticTransportation.DataStatistics') }}
            </span>
            <div
                style="width: 2px; margin: 3px 8px; background-color: #9c9c9c"
            ></div>
            <span style="color: #59b9d3">{{ $t('DomesticTransportation.OrderInquiry') }}</span>
            </div>
            <div class="scription-center" @click="showScription()"><i class="el-icon-collection" style="margin-right: 4px;"></i>{{ $t('DomesticTransportation.SubscriptionCenter') }}</div>
        </div>
        <div class="flex">
          <el-form
            style="flex: 1"
            ref="searchForm"
            :model="searchForm"
            label-width="100px"
          >
            <el-row :gutter="16">
              <el-col :span="10">
                <el-form-item :label="$t('DomesticTransportation.yourRefNo')">
                  <el-input
                    size="small"
                    v-model="searchForm.CustomerOrderNo"
                    :placeholder="$t('DomesticTransportation.Placeholder')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="箱罐号">
                  <el-input
                    size="small"
                    v-model="searchForm.ContainerNo"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="10">
                <el-form-item :label="$t('DomesticTransportation.OrderPlacementPeriod')">
                  <el-date-picker
                    v-model="orderDate"
                    type="daterange"
                    range-separator="~"
                    :start-placeholder="$t('DomesticTransportation.startDate')"
                    :end-placeholder="$t('DomesticTransportation.endDate')"
                    :picker-options="pickerOptions"
                    @change="searchTimeChange"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item :label="$t('DomesticTransportation.WaybillStatus')">
                  <el-select
                    size="small"
                    v-model="searchForm.Status"
                    style="width:100%"
                    :placeholder="$t('DomesticTransportation.Placeholder')"
                  >
                    <el-option
                      v-for="(item,index) in waybillStatusOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="8">
                <el-form-item label="产品编号MID">
                  <el-input
                    size="small"
                    v-model="searchForm.GoodsRemark"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="产品名称">
                  <el-input
                    size="small"
                    v-model="searchForm.GoodsNameCN"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Do">
                  <el-input
                    size="small"
                    v-model="searchForm.CustomerDNNo"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="车牌号">
                  <el-input
                    size="small"
                    v-model="searchForm.VehicleNo"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Shipto">
                  <el-input
                    size="small"
                    v-model="searchForm.TaskRemark"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              -->
            </el-row>
          </el-form>
          <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
          <div style="margin-top: 10px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              :loading="fullscreenLoading"
              @click="goSearch"
            >
            {{ $t('DomesticTransportation.Query') }}
            </el-button>
            <el-button
              size="small"
              icon="el-icon-refresh-right"
              :loading="fullscreenLoading"
              @click="reset"
            >
            {{ $t('DomesticTransportation.Reset') }}
            </el-button>
            <el-button
              size="small"
              icon="el-icon-download"
              :loading="fullscreenLoading"
              @click="exportOrder"
            >
            {{ $t('DomesticTransportation.Export') }}
            </el-button>
          </div>
        </div>
      </div>
      <div
        class="order-list"
        v-loading="fullscreenLoading"
        :element-loading-text="$t('DomesticTransportation.loadingStatus')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(196,196,204, 0.1)"
      >
        <!-- <div class="list-type">
          <div class="title">{{ $t('DomesticTransportation.DetailsView') }}</div>
          <el-tooltip class="item" effect="dark" :open-delay="500" :content="showType === 'card' ? '切换为列表模式':'切换为卡片模式'" placement="bottom">
            <img v-if="showType === 'card'" src="@/assets/tms/order_list_card.png" @click="showTypeChange('table')"/>
            <img v-else src="@/assets/tms/order_list_table.png" @click="showTypeChange('card')"/>
          </el-tooltip>
        </div> -->
        <!-- <div v-if="showType === 'card'">
          <Collapse v-if="listData && listData.length" :value="expandPanel">
            <Panel
              v-for="(item,index) in listData"
              :key="index"
              class="list-item"
              :name="item.CustomerOrderNo"
            >
              <div slot="header">
                <img
                  class="header_icon"
                  src="@/assets/tms/order_item_icon.png"
                />
                <div class="order-no">订单号：{{ item.CustomerOrderNo }}</div>
                <div class="order-head-infomation">
                  <Description
                    style="flex: 1"
                    :content="`运输方式：${item.OrderType}`"
                  />
                  <Description
                    style="flex: 1"
                    :content="`下单日期：${item.OrderDate}`"
                  />
                  <Description
                    style="flex: 1"
                    :content="`运单号：${item.TaskContainerID}`"
                  />
                  <Description
                    style="flex: 1"
                    :content="`参考运费：${item.RefCharges || '--'}`"
                  />
                </div>
              </div>
              <div slot="content">
                <div
                  class="detail-info"
                  v-for="waybill in item.TaskData"
                  :key="waybill.TaskContainerID"
                >
                  <div class="detail-info-status"></div>
                  <div class="detail-info-content">
                    <div style="display: flex;column-gap: 32px;">
                      <Description
                        style="flex: 2"
                        label="装货地址"
                        :content="waybill.LoadingAddress"
                      />
                      <Description
                        style="flex: 2"
                        label="卸货地址"
                        :content="waybill.UnLoadingAddress"
                      />
                      <Description
                        v-if="item.OrderType === '集罐运输'"
                        style="flex: 2"
                        label="箱/罐号"
                        :content="waybill.ContainerNo"
                      />
                      <Description
                        v-else
                        style="flex: 2"
                        label=""
                      />
                    </div>
                    <div style="display: flex; margin-top: 12px;column-gap: 32px;">
                      <Description
                        style="flex: 2"
                        label="总重量"
                        :content="waybill.GWT"
                      />
                      <Description
                        style="flex: 2"
                        label="产品"
                        :content="waybill.GoodsNameCN"
                      />
                      <Description
                        style="flex: 2"
                        label="时效（天）"
                        toolTip="时效 = 签收日期 - 提货日期"
                        :content="waybill.TimeConsume"
                      />
                    </div>
                    <OrderStep
                      style="margin-top: 20px"
                      :statuList="waybill.MilestoneData"
                    />
                  </div>
                  <div class="track-btn">
                    <el-tooltip
                      v-if="disabledTrack(waybill.MilestoneData)"
                      effect="dark"
                      content="暂无轨迹"
                      :disabled="false"
                      placement="top"
                      :enterable="false">
                      <span>
                        <el-button
                          type="primary"
                          disabled
                          size="small"
                          style="display: block; width: 100%"
                          @click="trackDetail(waybill.TaskContainerID,waybill.TaskID,item)"
                        >
                          查看轨迹
                        </el-button>
                      </span>
                    </el-tooltip>
                    <el-button
                      v-else
                      type="primary"
                      size="small"
                      style="display: block; width: 100%"
                      @click="trackDetail(waybill.TaskContainerID,waybill.TaskID,item)"
                    >
                      查看轨迹
                    </el-button>
                    <el-tooltip
                      v-if="waybill.EPODCount === 0"
                      effect="dark"
                      content="暂无回单"
                      :disabled="false"
                      :enterable="false"
                      placement="bottom">
                      <span>
                        <el-button
                          type="primary"
                          disabled
                          plain
                          size="small"
                          style="margin-left: 0px; width: 100%; margin-top: 8px"
                          @click="openReceipt(waybill,item.OrderID)"
                        >
                          查看回单
                        </el-button>
                      </span>
                    </el-tooltip>
                    <el-button
                      v-else
                      type="primary"
                      plain
                      size="small"
                      style="margin-left: 0px; width: 100%; margin-top: 8px"
                      @click="openReceipt(waybill,item.OrderID)"
                    >
                      查看回单
                    </el-button>
                  </div>
                </div>
              </div>
            </Panel>
          </Collapse>
          <div v-else style="text-align: center; padding: 20px">暂无数据</div>
        </div> -->
        <div class="title">{{ $t('DomesticTransportation.DetailsView') }}</div>
        <el-table ref="orderTable" :data="listData" height="calc(100vh - 361px)">
          <el-table-column type="index" width="80" align="center" :label="$t('DomesticTransportation.SerialNo')">
          </el-table-column>
          <el-table-column prop="CustomerOrderNo" width="120" show-overflow-tooltip :label="$t('DomesticTransportation.OrderNo')">
          </el-table-column>
          <el-table-column prop="TaskContainerID" width="130" :label="$t('DomesticTransportation.WaybillNo')">
          </el-table-column>
          <!-- <el-table-column prop="RefCharges" width="145" align="center" :label="$t('DomesticTransportation.ReferenceFreightCost')"> </el-table-column>
          <el-table-column prop="TaskContainerStatus" width="120" align="center" :label="$t('DomesticTransportation.WaybillStatus')">
            <template slot-scope="{row}">
                <div>{{ changeLang(row.TaskContainerStatus) }}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="OrderType" width="136" align="center" :label="$t('DomesticTransportation.TransportationMode')">
            <template slot-scope="{row}">
                <div>{{ changeLang(row.OrderType) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="OrderDate" width="100" :label="$t('DomesticTransportation.OrderDate')"> </el-table-column>
          <el-table-column prop="GoodsNameCN" width="150" show-overflow-tooltip :label="$t('DomesticTransportation.Product')"> </el-table-column>
          <el-table-column prop="NWT" width="120" align="center" :label="$t('DomesticTransportation.TotalWeight')"> </el-table-column>
          <el-table-column prop="LoadingAddress" show-overflow-tooltip min-width="150" :label="$t('DomesticTransportation.LoadingAddress')"> </el-table-column>
          <el-table-column prop="UnLoadingAddress" show-overflow-tooltip min-width="150" :label="$t('DomesticTransportation.UnloadingAddress')"> </el-table-column>
          <el-table-column :width="lang == 'zh' ? 120 : 170" :label="$t('DomesticTransportation.Actions')" fixed="right">
            <template slot-scope="scope">
              <el-tooltip
                v-if="disabledTrack(scope.row.MilestoneData)"
                effect="dark"
                :content="$t('DomesticTransportation.Notracksavailable')"
                :disabled="false"
                placement="top"
                :enterable="false">
                <span><el-button @click="trackDetail(scope.row.TaskContainerID, scope.row.TaskID,scope.row)" type="text" disabled size="small">{{ $t('DomesticTransportation.Tracking') }}</el-button></span>
              </el-tooltip>
              <el-button v-else @click="trackDetail(scope.row.TaskContainerID, scope.row.TaskID,scope.row)" type="text" size="small">{{ $t('DomesticTransportation.Tracking') }}</el-button>
              <el-tooltip
                v-if="scope.row.EPODCount === 0"
                effect="dark"
                :content="$t('DomesticTransportation.Noreceiptreturnedyet')"
                :disabled="false"
                :enterable="false"
                placement="top"
                style="margin-left: 10px;">
                <span><el-button @click="openReceipt(scope.row)" disabled type="text" size="small">{{ $t('DomesticTransportation.ReceiptProof') }}</el-button></span>
              </el-tooltip>
              <el-button v-else @click="openReceipt(scope.row)" type="text" size="small" :style="{marginLeft:disabledTrack(scope.row.MilestoneData)? '10px' : ''}">{{ $t('DomesticTransportation.ReceiptProof') }}</el-button>
              <el-button type="text" size="small" :loading="scope.row.loading" style="margin-left: 10px;color:#53a2b6" @click="attention(scope.row,scope.$index)">{{ scope.row.loading ? '' : (scope.row.IsSubscription ? $t('DomesticTransportation.Unfollow') : $t('DomesticTransportation.Follow') ) }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="foot-tip">
        <i class="el-icon-warning-outline"></i>
        {{ $t('DomesticTransportation.statement') }}
      </div>
      <!-- <div class="explain">
        <div><i class="el-icon-info" style="color:#53a2b6;margin-right: 8px;" ></i>{{ $t('DomesticTransportation.Instructions1') }}</div>
        <div :style="{marginLeft:lang == 'zh'? '44px': '85px',marginTop: '4px'}">{{ $t('DomesticTransportation.Instructions2') }}</div>
        <div :style="{marginLeft:lang == 'zh'? '44px': '85px',marginTop: '4px'}">{{ $t('DomesticTransportation.Instructions3') }}</div>
      </div> -->
      <div class="pagination-info">
        <div style="color:#999;font-size: 12px;margin-left: 220px;"></div>
        <el-pagination
          background
          :page-size="pageInfo.PageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="prev,sizes, pager, next"
          @current-page="pageInfo.PageIndex"
          @current-change="currentChange"
          @size-change="handleSizeChange"
          :total="pageInfo.Total"
        >
        </el-pagination>
      </div>

      <MapTrack
        ref="mapTrack"
        :mapTrackVisible="mapTrack"
        @close="mapTrack = false"
      />
      <el-dialog
        custom-class="receipt-dialog"
        :title="$t('DomesticTransportation.ViewReceiptProof')"
        :visible.sync="receiptVisible"
        width="30%"
      >
        <div v-for="file in receiptList" :key="file" class="receipt-img">
          <div v-if="pictureTypeOptions.includes(judgeType(file))">
            <img style="width:100%;height:100%;object-fit: contain;" :src="file" />
            <div class="opeartor">
              <el-button
                type="primary"
                size="small"
                style="display: block; width: 100%"
                @click="preview(file)"
              >
                {{ $t('DomesticTransportation.view') }}
              </el-button>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 0px; width: 100%; margin-top: 8px"
                @click="downloadIamge(file,'回单')"
              >
              {{ $t('DomesticTransportation.download') }}
              </el-button>
            </div>
          </div>
          <div v-else style="margin-top: 32px;">
            <img style="width:64px;height:64px;margin-bottom: 8px;" src="@/assets/tms/unknown_file.png" />
            <div>{{ $t('DomesticTransportation.dontPreview') }}</div>
            <div><a @click="downloadIamge(file,'回单文件')">{{ $t('DomesticTransportation.download') }}</a></div>
          </div>
        </div>
      </el-dialog>
      <div style="display:none">
        <viewer :images="viewerUrl" @inited="inited" class="viewer" ref="viewer">
          <template #default="scope">
            <img :src="viewerUrl[0]" />
            {{ scope }}
          </template>
        </viewer>
      </div>
      <ScriptCenter ref="subScriptCenter" @success="$refs.SubscriptionSuccess.open()"/>
      <SubscriptionSuccess ref="SubscriptionSuccess" />
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import { Collapse, Panel } from '@/components/OrderCollapse'
import Description from '@/components/Description'
import OrderStep from './components/orderStep.vue'
import MapTrack from './components/mapTrack.vue'
import { getorderlist, getreceiptlist, exportorderlist, downloadFile, subscriptionorder } from '@/api/tms'
import ScriptCenter from '@/components/scriptCenter.vue'
import SubscriptionSuccess from '@/components/subscriptionSuccess.vue'
import i18n from '@/i18n/i18n'
import moment from 'moment'
export default {
  components: {
    PageView,
    Collapse,
    Panel,
    Description,
    OrderStep,
    MapTrack,
    ScriptCenter,
    SubscriptionSuccess
  },
  data() {
    return {
      searchForm: {
        Status: '全部'
      },
      pageInfo: {
        PageIndex: 1,
        PageSize: 10,
        Total: 0
      },
      listData: [],
      mapTrack: false,
      expandPanel: [],
      orderDate: [],
      fullscreenLoading: false,
      showType: 'table',
      receiptVisible: false,
      viewerUrl: [],
      receiptList: [],
      pictureTypeOptions: ['jpg', 'png', 'jpeg', 'gif'],
      waybillStatusOptions: [
        { label: i18n.t('DomesticTransportation.All'), value: '全部' },
        { label: i18n.t('DomesticTransportation.AwaitingPickup'), value: '待提货' },
        { label: i18n.t('DomesticTransportation.PickedUp'), value: '已提货' },
        { label: i18n.t('DomesticTransportation.InTransit'), value: '运输中' },
        { label: i18n.t('DomesticTransportation.OutforDelivery'), value: '派送中' },
        { label: i18n.t('DomesticTransportation.Signedfor'), value: '已签收' },
        { label: i18n.t('DomesticTransportation.PickupDelayed'), value: '提货延误' },
        { label: i18n.t('DomesticTransportation.DeliveryDelayed'), value: '送货延误' },
      ],
      selectData: '',
      pickerOptions: {
        // onPick：选中日期后会执行的回调。写成箭头函数否则this.selectData会报错
        // 点击时，选择的是初始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 第二次点击日期选择器，选好初始时间和结束时间后，解除禁用限制
            this.selectData = ''
          }
        },
        // 设置禁用状态，参数为当前日期，要求返回 Boolean。同理写成箭头函数
        disabledDate: (time) => {
          // 是否限制的判断条件，if里写点击了初始时间后的判断条件
          // 即第二个选择的时间前后不能超过初始时间的一个月
          if (this.selectData) {
            return time.getTime() > new Date() || time.getTime() > this.selectData + 30 * 24 * 3600 * 1000 || time.getTime() < this.selectData - 30 * 24 * 3600 * 1000;
            // time.getTime() > new Date() 为所选时间不能超过今日
            // 30 * 24 * 3600 * 1000则为一个月的毫秒数，根据自己的需求修改限制的时间范围
          } else {
            return time.getTime() > new Date();
            // 如果不需要限制所选时间不能超过今日，则直接return false即可
          }
        }
      },
      lang: 'zh'
    }
  },
  watch: {
    listData: {
      handler(newValue, oldValue) {
        this.expandPanel = this.listData.map((item) => {
          return item.CustomerOrderNo
        })
      },
      deep: true
    }
  },
  mounted() {
    const startDate = this.$route.query.startDate || ''
    const endDate = this.$route.query.endDate || ''
    if (startDate && endDate) {
      this.orderDate = [startDate, endDate]
      this.searchTimeChange(this.orderDate)
    }
    this.searchForm.Status = this.$route.query.type || '全部'
    this.lang = this.$ls.get('lang')
    this.getData()
  },
  methods: {
    getData() {
      const params = {
        ...this.searchForm,
        PageIndex: this.pageInfo.PageIndex,
        PageSize: this.pageInfo.PageSize,
        ShowType: this.showType
      }
      this.listData = []
      this.fullscreenLoading = true
      getorderlist(params)
        .then((res) => {
          this.fullscreenLoading = false
          if (!res.Data) return
          const data = res.Data.Data || []
          this.listData = data.map(el => { return { ...el, loading: false } })
          this.pageInfo.Total = res.Data.Total
          if (this.pageInfo.PageIndex > 1 && !res.Data.Data.length) {
            this.goSearch()
          }
        })
        .catch(() => {
          this.fullscreenLoading = false
        })
    },
    trackDetail(TaskContainerID, TaskID) {
    //   const loadLngLat = [item.LoadingLng, item.LoadingLat]
    //   const unloadLngLat = [item.UnLoadingLng, item.UnLoadingLat]
    //   const loadAddress = item.LoadingAddress
    //   const unloadAddress = item.UnLoadingAddress
    //   const OrderID = item.OrderID
    //   const TaskContainerStatus = item.TaskContainerStatus
      //   this.mapTrack = true
      //   this.$refs.mapTrack.init(TaskContainerID, TaskID, loadLngLat, unloadLngLat, loadAddress, unloadAddress)
    //   Cookies.set('TaskContainerID', TaskContainerID)
    //   Cookies.set('TaskID', TaskID)
    //   Cookies.set('loadLngLat', JSON.stringify(loadLngLat))
    //   Cookies.set('unloadLngLat', JSON.stringify(unloadLngLat))
    //   Cookies.set('loadAddress', loadAddress)
    //   Cookies.set('unloadAddress', unloadAddress)
    //   Cookies.set('OrderID', OrderID)
    //   Cookies.set('TaskContainerStatus', TaskContainerStatus)
    //   const addressInfo = {
    //     TaskContainerID: item.TaskContainerID,
    //     PickCity: item.LoadingLocCityLongName,
    //     PickArea: item.LoadingLocDistrictLongName,
    //     PickContact: item.LoadingContact,
    //     LoadingLocaName: item.LoadingLocaName,
    //     DropCity: item.UnLoadingLocCityLongName,
    //     DropArea: item.UnLoadingLocDistrictLongName,
    //     DropContact: item.UnLoadingContact,
    //     UnLoadingLocaName: item.UnLoadingLocaName
    //   }
    //   Cookies.set('AddressInfo', JSON.stringify(addressInfo))

      window.open(`/map-track?jobID=${TaskID}`, '_blank')
    },
    goSearch() {
      this.pageInfo = {
        PageIndex: 1,
        PageSize: this.pageInfo.PageSize,
        Total: 0
      }
      this.getData()
    },
    reset() {
    //   this.searchForm = {}
    //   this.orderDate = []
      this.searchForm.CustomerOrderNo = ''
      const startDate = this.$route.query.startDate || ''
      const endDate = this.$route.query.endDate || ''
      if (startDate && endDate) {
        this.orderDate = [startDate, endDate]
        this.searchTimeChange(this.orderDate)
      }
      this.goSearch()
    },
    currentChange(value) {
      this.pageInfo.PageIndex = value
      this.getData()
    },
    handleSizeChange(val) {
      this.pageInfo.PageSize = val
      this.goSearch()
    },
    searchTimeChange(value) {
      this.searchForm.OrderDateStart = moment(value[0]).format('yyyy-MM-DD')
      this.searchForm.OrderDateEnd = moment(value[1]).format('yyyy-MM-DD')
    },
    goBoard() {
      this.$router.push({
        name: 'dataBoard'
      })
    },
    downloadIamge(imgsrc, name) { // 下载图片地址和图片名
      if (!imgsrc || imgsrc.indexOf('fileserver') === -1) return
      const url = 'https://cors.mcpsystem.com/' + imgsrc.substring(imgsrc.indexOf('fileserver'))
      downloadFile(url).then((result) => {

      })
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    preview(url) {
      this.viewerUrl = [url]
      this.$viewer.show()
    },
    openReceipt(row, OrderID) {
      const params = {
        TaskID: row.TaskID,
        TaskContainerID: row.TaskContainerID,
        OrderID: OrderID || row.OrderID
      }
      getreceiptlist(params).then(res => {
        this.receiptList = res.Data || []
        if (res.Data && res.Data.length) {
          this.receiptVisible = true
        } else {
          this.$message({
            message: i18n.t('DomesticTransportation.Noreceiptreturnedyet'),
            type: 'warning'
          })
        }
      })
    },
    attention(row, index) {
      this.listData[index].loading = true
      subscriptionorder({ TaskID: row.TaskID, IsSubscription: row.IsSubscription ? '取消关注' : '关注' }).then(res => {
        row.IsSubscription = !row.IsSubscription
      }).finally(() => {
        this.listData[index].loading = false
      })
    },
    judgeType(file) {
      if (!file) return
      const _index = file.lastIndexOf('.')
      const src = file.slice(_index + 1)
      return src
    },
    // 订单导出
    exportOrder() {
      this.fullscreenLoading = true
      const params = {
        ...this.searchForm,
        PageIndex: this.pageInfo.PageIndex,
        PageSize: this.pageInfo.PageSize
      }

      exportorderlist(params).then(res => {
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
    },
    disabledTrack(MilestoneData) {
      let able = true
      MilestoneData.forEach(el => {
        if (el.IsActive && el.Sort !== 1) {
          able = false
        }
      })
      return able
    },
    showTypeChange(type) {
      this.showType = type
      this.getData()
    },
    showScription() {
      this.$refs.subScriptCenter.open('TMS')
    },
    changeLang(status){
        let value = ''
        if(this.lang === 'zh'){
            value = status
        }else {
            if(status === '国内配送'){
                value = 'Distribution Services'
            }else if(status === '集卡运输'){
                value = 'Container Trucking'
            }else if(status === '已接单'){
                value = 'Picked Up'
            }else if(status === '运输中'){
                value = 'In Transit'
            }else if(status === '已签收'){
                value = 'Delivered'
            }else if(status === '派送中'){
                value = 'Out for Delivery'
            }
        }
        return value
    }
  }
}
</script>
<style lang="less">
.tms-shell-order {
  padding: 10px;
  background: #f0f6fb;
  position: relative;
  ::-webkit-scrollbar{
    display: block;
    height:16px;
    background-color: #F3F4F6;
    box-shadow:none
  }
  ::-webkit-scrollbar-track {
    background-color: white;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #F3F4F6;
  }
  .el-table .el-table__fixed-right .el-table__fixed-body-wrapper .el-table__body {
      padding-bottom: 16px!important;
  }
  .plr25 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .ptb25 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
    .scription-center {
        border: 1px solid #53a2b6;
        color: #53a2b6;
        height: 30px;
        line-height: 18px;
        border-radius: 4px;
        padding:4px 16px;
        cursor: pointer;
    }
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    overflow: auto;
    .list-item {
      margin-bottom: 8px;
    }
  }
  .explain {
    background-color: #EEF5FE;
    padding: 8px;
    margin-top: 8px;
    font-size: 12px;
  }
  .foot-tip {
    height: 36px;
    line-height: 36px;
    background-color: #F0F6FC;
    color: #8CA2BD;
    font-size: 12px;
    opacity: 0.85;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 50px;
    padding-left: 208px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .list-type {
    display: flex;
    justify-content: space-between;
    img {
      width: 20px;
      height: 20px;
      display: inline-block;
      cursor: pointer;
      transition: all 0.5s ease 0.1s;
    }
    img:hover {
      transform: scale(1.3);
    }
  }
  .header_icon {
    width: 34px;
    height: 34px;
    display: inline-block;
  }
  .order-no {
    font-size: 16px;
    font-weight: 400;
    color: #111827;
    margin-left: 18px;
    display: inline-block;
  }
  .order-head-infomation {
    padding-left: 52px;
    display: flex;
    justify-content: flex;
  }
  .detail-info {
    border-radius: 10px;
    // border: 1px solid #e9ecf2;
    padding: 16px 0;
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #f6f6f8;
    .detail-info-status {
      background: #59b9d3;
      width: 3px;
      margin-left: -1px;
      border-radius: 0 16px 16px 0;
    }
    .detail-info-content {
      flex: 1;
      margin-left: 20px;
    }
    .track-btn {
      width: 108px;
      margin-right: 30px;
    }
  }
  .pagination-info {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    z-index: 3;
  }
  .receipt-img {
    border:1px solid #c1c1c1;
    border-radius: 4px;
    margin-bottom: 8px;
    text-align: center;
    position: relative;
    min-height: 180px;
  }
  .receipt-dialog {
    .el-dialog__body {
        height: 70vh;
        overflow-y: scroll;
        padding:10px;
        padding-right: 0;
    }
  }
  .opeartor {
    position: absolute;
    right:8px;
    top:8px;
  }
}
</style>
